/**
 * Hub-internal query parameters that must not travel in a shared link: an alert link's own fields
 * (they would replay the alert for whoever opens it), setup and preview controls, and tracking.
 */
const PRIVATE_PARAMS = [
  'hubAlert',
  'facilityId',
  'entityId',
  'packageId',
  'tested',
  'hubAlertSetupMode',
  'hubAlertSetupReset',
];

/** The current Hub page as a link to share with someone else. */
export const shareableUrl = (href: string) => {
  try {
    const url = new URL(href);
    [...url.searchParams.keys()]
      .filter(key => PRIVATE_PARAMS.includes(key) || key.startsWith('utm_'))
      .forEach(key => url.searchParams.delete(key));
    return url.toString();
  } catch {
    return href;
  }
};

/**
 * Android shares through the phone's share sheet (WhatsApp, Slack, Copy); computers copy, which is
 * what people do from the address bar today.
 */
export const shareMethod = (
  platform: 'android' | 'windows' | 'mac' | 'other',
  canShare: boolean,
): 'share' | 'copy' => (platform === 'android' && canShare ? 'share' : 'copy');
